export const breakpoints = {
    xs: 0,
    sm: 600,
    md: 1200,
    lg: 1280,
    xl: 1920
};
